import React from 'react';
import { AuthLayout } from '../../../components/layout/Layouts';
import AllStaff from '../../../components/Dashboard/AllStaff'; 

const AllStaffPage = () => {
  return (
    <AuthLayout>
      <AllStaff />
    </AuthLayout>
  );
};

export default AllStaffPage;
